import Vector from "victor";
import {
  ShapeWithCanvasBasedDOMRepresentation2,
  ShapeTranslatable2,
  ShapeSizeable2,
} from "./types/Shape";
import Rect from "./types/Rect";
import {
  HasBoundingBoxOriginalSize,
  HasBoundingBoxSize,
  HasFillColor,
  HasStrokeColor,
  HasStrokeWidth,
  PartialUnknownShape,
} from "./types/attributes";

export function duple<T>(items: T[]): [T, T] {
  return [items[0], items[1]];
}

export function choice<T>(items: T[], n: number): T {
  return items[Math.floor(items.length * n)];
}

export function shapeTruePosition2(shape: ShapeTranslatable2): Vector {
  return new Vector(
    shape.boundingBoxOrigin[0] + shape.translate[0],
    shape.boundingBoxOrigin[1] + shape.translate[1]
  );
}

export function needsZoomAdjustment(shape: unknown): boolean {
  const castedShape = shape as HasBoundingBoxSize & HasBoundingBoxOriginalSize;
  return !!(castedShape.boundingBoxSize && castedShape.boundingBoxOriginalSize);
}

export function shapeStrokeWidthScale(
  shape: ShapeWithCanvasBasedDOMRepresentation2
): number {
  if (shape.strokeWidthScalesToScreen === true) {
    return 1;
  } else {
    return shapeScale2(shape).x;
  }
}

export function shapeScale2(
  shape: ShapeWithCanvasBasedDOMRepresentation2
): Vector {
  return Vector.fromArray(shape.boundingBoxOriginalSize).divide(
    Vector.fromArray(shape.boundingBoxSize)
  );
}

export function shapeBoundingRect2(shape: ShapeSizeable2): Rect {
  const origin = Vector.fromArray(shape.boundingBoxOrigin).add(
    Vector.fromArray(shape.translate)
  );
  return new Rect(
    origin,
    origin.clone().add(Vector.fromArray(shape.boundingBoxSize))
  );
}

export function getShapeStrokeColor(shape: unknown): string | null {
  if (shape as HasStrokeColor) {
    return (shape as HasStrokeColor).strokeColor || null;
  } else {
    return null;
  }
}

export function getShapeStrokeWidth(shape: unknown): number | null {
  if (shape as HasStrokeWidth) {
    return (shape as HasStrokeWidth).strokeWidth || null;
  } else {
    return null;
  }
}

export function getShapeFillColor(shape: unknown): string | null {
  if (shape as HasFillColor) {
    return (shape as HasFillColor).fillColor || null;
  } else {
    return null;
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getStandardPadding(shape: PartialUnknownShape): Vector {
  // We could get fancy with exact margins, but we want to be able to change settings,
  // so just add an even 100px.
  return new Vector(100, 100);
  // // Multiple of strokeWidth. Adds padding around the exact points so
  // // there's room to draw things like arrows.
  // const value = new Vector(0, 0);
  // if (shape.strokeWidth) {
  //   value.addScalar(shape.strokeWidth);
  // }
  // return value;
}

/**
 * Discard all calls to `fn` unless `delay` milliseconds have passed
 */
export function throttleLeading<T extends Function>(
  obj: unknown,
  delay: number,
  fn: T
): T {
  let lastCall = 0;
  const boundFn = fn.bind(obj);
  return function (...args: unknown[]) {
    const t = Date.now();
    const dt = t - lastCall;
    if (dt > delay) {
      lastCall = t;
      return boundFn(...args);
    }
  }.bind(obj) as unknown as T;
}

export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
